import { MenuEntry } from '@pancakeswap-libs/uikit'

const config: MenuEntry[] = [
  {
    label: 'Home',
    icon: 'HomeIcon',
    href: 'https://dapp.shanum.finance/'
  },
  {
    label: 'Trade',
    icon: 'TradeIcon',
    initialOpenState: true,
    items: [
      {
        label: 'Exchange',
        href: '/swap'
      },
      {
        label: 'Liquidity',
        href: '/pool'
      }
    ]
  },


  {
    label: 'Staking Pools',
    icon: 'PoolIcon',
    href: 'https://dapp.shanum.finance/'
  },
  
  // {
  //   label: 'Lottery',
  //   icon: 'TicketIcon',
  //   href: 'https://www.goosedefi.com/lottery'
  //  },

 {
   label: 'Info',
   icon: 'InfoIcon',
   items: [
    {
      label: 'Coinmarketcap',
       href: 'https://coinmarketcap.com/currencies/shanum/',
     },
     {
      label: 'Github',
       href: 'https://github.com/shanumproject/',
     },
    ]
   },
   

  // {
  //   label: 'More',
  //   icon: 'MoreIcon',
  //   items: [
  //     // {
  //     //   label: 'Voting',
  //     //   href: 'https://voting.pancakeswap.finance',
  //     // },
  //     {
  //       label: "Github",
  //       href: "https://github.com/pastafinance/",
  //     },
  //   ],
  // }
]

export default config
